var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"app__root"},[_c('CameraFeed'),_c('PlasticLayer',{attrs:{"background":_vm.tapped ? 'transparent' : 'black'}}),_c('ModelLayer'),(!_vm.tapped)?_c('Loader'):_vm._e(),_c('RotateDevice')],1)}
var staticRenderFns = []

export { render, staticRenderFns }